import axios from 'axios'

export const getAssetById = data => {
    return axios.post('/ajax/fleet/itemById', data)
}
export const updateAsset = data => {
    return axios.post('/ajax/fleet/update', data)
}
export const getAsset = data => {
    return axios.post('/ajax/fleet/item', data)
}
export const searchFleet = data => {
    return axios.post('/ajax/fleet/list', data)
}
export const createAsset = data => {
    return axios.post('/ajax/fleet/create', data)
}
export const getMakeAndModel = () => {
    return axios.get('/ajax/fleet/make-model')
}
